import React from 'react';
import { Modal, ModalOverlay, ModalContent } from '@chakra-ui/react';

const ModalTemplate = ({
    isOpen,
    onClose,
    children,
    width,
    modalContentCustomStyle,
    borderRadius = '12px',
    isClosebyOverlayClick = true,
    isCentered = true,
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered={isCentered} closeOnOverlayClick={isClosebyOverlayClick}>
            <ModalOverlay
                background={'rgba(0,0,0,0.7)'}
                onClick={onClose}
                data-testid="modal-overlay__modal-template"
            />
            <ModalContent
                style={{ ...modalContentCustomStyle }}
                width={width}
                maxWidth={'none'}
                borderRadius={borderRadius}
            >
                {children}
            </ModalContent>
        </Modal>
    );
};

export default ModalTemplate;
